import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import FlexItem from "@insite/content-library/Widgets/Brand/FlexItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import TradeAccountIcon from "@tSurya/Icons/TradeAccountIcon";
import React, { FC, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface HeaderContainerStyle {
    headerContainer?: InjectableCss;
    headerSection?: InjectableCss;
    borderBottom?: InjectableCss;
    signInborderBottom?: InjectableCss;
    logoSearchContainer?: InjectableCss;
    logo?: InjectableCss;
    search?: InjectableCss;
    newBrandLogo?: InjectableCss;
    openTrade?: InjectableCss;
    myAccount?: InjectableCss;
    signInAccount?: InjectableCss;
    mainNavigation?: InjectableCss;
    cart?: InjectableCss;
    signIn?: HiddenProps;
}

export const headerContainerStyle: HeaderContainerStyle = {
    headerContainer: {
        css: css`
            background: #ffffff;
        `,
    },

    headerSection: {
        css: css`
            @media (min-width: 992px) and (max-width: 1166px) {
                display: flex;
                align-items: center;
                justify-content: space-between;
                max-width: calc(100% - 40px);
                margin: 0 auto;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            max-width: calc(100% - 40px);
                            margin: 0 auto;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    borderBottom: {
        css: css`
            border-bottom: 1px solid #e0e0e0;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    null,
                    null,
                ]);
            }}
            @media (min-width: 992px) and (max-width: 1166px) {
                border-bottom: none !important;
                width: 100% !important;
                order: 2 !important;
            }
        `,
    },
    signInborderBottom: {
        css: css`
            border-bottom: 1px solid #e0e0e0;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    null,
                    null,
                ]);
            }}

            @media (min-width: 992px) and (max-width: 1166px) {
                border-bottom: none !important;
                width: 100% !important;
                order: 2 !important;
            }
        `,
    },
    logoSearchContainer: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 1280px;
            margin: 0 auto;
            padding: 29px 0px;
            max-height: 80px;

            @media (min-width: 992px) and (max-width: 1166px) {
                max-width: 100% !important;
                padding: 0px !important;
                margin: 21px 0px !important;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 100% !important;
                            padding: 0px;
                            margin: 21px 0px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            @media only screen and (max-width: 1280px) {
                padding-left: 15px;
                padding-right: 15px;
            }
            @media only screen and (max-width: 992px) {
                padding-left: 0px;
                padding-right: 0px;
            }
        `,
    },
    mainNavigation: {
        css: css`
            max-width: 1280px;
            max-height: 42px;
            margin: 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            order: 1;
                            margin: 0;
                        `,
                        css``,
                        null,
                    ],
                    "max",
                );
            }}
            @media (min-width: 992px) and (max-width: 1166px) {
                order: 1 !important;
                margin: 0 !important;
            }
        `,
    },
    logo: {
        css: css`
            width: 20%;
            padding-top: 5px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: auto;
                            margin: 0 auto;
                            padding-top: 0px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            @media (min-width: 992px) and (max-width: 1166px) {
                width: auto !important;
                margin: 0 auto !important;
                padding-top: 0px !important;
            }
        `,
    },
    search: {
        css: css`
            width: 25%;
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    newBrandLogo: {
        css: css`
            margin-left: 90px;
            margin-right:30px;
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    openTrade: {
        css: css`
            width: 20%;
            padding-bottom: 2px;
            margin-left:10px;
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    signInAccount: {
        css: css`
            width: 10%;
            //margin-left: -30px;
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
            
        `,
    },
    myAccount: {
        css: css`
            width: 18%;
            margin-left: 20px;
            @media (min-width: 992px) and (max-width: 1166px) {
                display: none !important;
            }
        `,
    },
    cart: {
        css: css`
         @media (min-width: 992px) and (max-width: 1166px) {
                display:flex !important;
                justify-content: end ;
            }
            > div {
                display: flex;
                justify-content: end;
            }
        `,
    },
    signIn: {
        css: css`
            @media (min-width: 992px) and (max-width: 1166px) {
                display:flex !important;
                justify-content: end;
            }
            > div {
                display: flex;
                justify-content: end;
            }
        `,
    },
};

const styles = headerContainerStyle;

export const HeaderContainer: FC<Props> = ({ id, session }) => {
    return (
        <StyledWrapper {...styles.headerContainer}>
            <StyledWrapper {...styles.headerSection}>
                <StyledWrapper {...(!session.isAuthenticated ? styles.borderBottom : styles.signInborderBottom)}>
                    <StyledWrapper {...styles.logoSearchContainer}>
                        <StyledWrapper {...styles.logo}>
                            <Zone contentId={id} zoneName="Logo" />
                        </StyledWrapper>
                        <Hidden below="lg" {...styles.search}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="Search" />
                            </StyledWrapper>
                        </Hidden>
                        <Hidden below="lg" {...styles.newBrandLogo}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="newBrandLogo"/>
                            </StyledWrapper>
                        </Hidden>
                        {!session.isAuthenticated && (
                            <Hidden below="lg" {...styles.openTrade}>
                                <StyledWrapper>
                                    <Zone contentId={id} zoneName="OpenTrade" />
                                </StyledWrapper>
                            </Hidden>
                        )}
                        <Hidden below="lg" {...(!session.isAuthenticated ? styles.signInAccount : styles.myAccount)}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="MyAccount" />
                            </StyledWrapper>
                        </Hidden>
                        {session.isAuthenticated && (
                            <StyledWrapper {...styles.cart}>
                                <Zone contentId={id} zoneName="Cart" />
                            </StyledWrapper>
                        )}
                        {!session.isAuthenticated && (
                            <Hidden above="md" {...styles.signIn}>
                                <Zone contentId={id} zoneName="SignIn" />
                            </Hidden>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.mainNavigation}>
                    <Zone contentId={id} zoneName="mainNavigation" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(HeaderContainer),
    definition: {
        group: "Basic",
        displayName: "Header Container",
    },
};

export default widgetModule;
